// 调用 cocos 客户端 通信
export function toCocosFun(data) {
  // 关闭窗口
  let params = window.localStorage.getItem("localInitQuery");
  if (params) {
    params = JSON.parse(params);
  }
  console.log("params", params);
  try {
    if (params.app == "ios") {
      window["webkit"] &&
        window["webkit"].messageHandlers &&
        window["webkit"].messageHandlers.sendMessageToCocos &&
        window["webkit"].messageHandlers.sendMessageToCocos.postMessage(
          JSON.stringify(data)
        );
    } else {
      window["AndroidApp"] &&
        window["AndroidApp"].sendMessageToCocos &&
        window["AndroidApp"].sendMessageToCocos(JSON.stringify(data));
    }
  } catch (error) {
    console.log(error, "-----调用 cocos 客户端错误");
  }
}

// 调用 cocos adjust 通信
export function toCocosAdjustFun(eventToken) {
  try {
    if (eventToken) {
      const data = {
        type: "adjust",
        value: eventToken,
      };
      window["webkit"] &&
        window["webkit"].messageHandlers &&
        window["webkit"].messageHandlers.sendMessageToCocos &&
        window["webkit"].messageHandlers.sendMessageToCocos.postMessage(
          JSON.stringify(data)
        );
      window["AndroidApp"] &&
        window["AndroidApp"].sendMessageToCocos &&
        window["AndroidApp"].sendMessageToCocos(JSON.stringify(data));
    }
  } catch (error) {
    console.log(error, "-----调用 cocos 客户端错误");
  }
}

// 调用 cocos 客户端 下载
export function cocosDownload(text) {
  const eventName = [
    "download",
    "cocosDownload",
    "pcDownload",
    "h5Download",
    "anDownload",
  ];
  const index = Math.floor(Math.random() * eventName.length);
  const curEvent = eventName[index];
  toCocosFun({
    type: curEvent,
    value: {
      url: text,
    },
  });
}
